module.exports = __webpack_public_path__ + "static/art-and-science@2x.5212664b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/guides/img/art-and-science@2x.png
// module id = 816
// module chunks = 35783957827783